/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col, Form, Spin, Checkbox, Slider, Switch, InputNumber  } from 'antd';
import { useAppContext } from "../../../context/appContext";
import { CloseOutlined } from '@ant-design/icons';
import fetchUserSettingsInterval from "../..//common/helpers/fetch-user-settings-interval";
import updateUserSettingsInterval from "../..//common/helpers/update-user-settings-interval";
import { userId } from "../../../context/appContext";
import { DeleteOutlined } from '@ant-design/icons';
const { TextArea } = Input;
const AdvancedFilter = ({ showAdvancedFilter, setShowAdvancedFilter, currentFilters, configureFilters }) => {

    const [intervalSettings, setIntervalSettings] = useState({
        edge_case_interval: null,
        balance_interval: null,
        non_stream_interval: null,
    })

    const fieldKeyValue = {
        'symbol': { type: 'string', label: 'Symbol' },
        'spread': { type: 'range', label: 'Spread', value:[1, 10], step: 0.0001 },
        'timer':  { type: 'range', label: 'Timer', value:[1, 10] },
        'side':  { type: 'dropdown', label: 'Side', options: ['buy', 'sell'] },
        'minimum_size':  { type: 'range', label: 'Minimum size', value:[1, 10] },
        'maximum_size':  { type: 'range', label: 'Maximum size', value:[1, 10] },
        'source':  { type: 'string', label: 'Source' },
        'source_symbol':  { type: 'string', label: 'Source Symbol' },
        'rebalance_symbol':  { type: 'string', label: 'Rebalance Symbol' },
        'sensitivity':  { type: 'range', label: 'Sensitivity', value:[1, 10] },
        'paused':  { type: 'boolean', label: 'Paused' }
    }
    
    const [showAddFilter, setShowAddFilter] = useState(false);
    const [filters, setFilters] = useState([
        { field: 'symbol',  type: 'string', label: 'Symbol', value: null }
    ]);
    const [fields, setFields] = useState([
        { value:'symbol', label: 'Symbol' },
        { value:'spread', label: 'Spread' },
        { value:'timer', label: 'Timer' },
        { value:'side', label: 'Side' },
        { value:'minimum_size', label: 'Minimum size' },
        { value:'maximum_size', label: 'Maximum size' },
        { value:'source', label: 'Source' },
        { value:'sensitivity', label: 'Sensitivity' },
        { value:'paused', label: 'Paused' },
        { value:'source_symbol', label: 'Source Symbol' },
        { value:'rebalance_symbol', label: 'Rebalance Symbol' },
    ]);

    const [field, setField] = useState();

    useEffect(() => {

       if(currentFilters){
        setFilters(currentFilters);
       }
    }, [])


    const goBack = () => {
        setShowAdvancedFilter(false)
    }


    const handleFilters = () => {
        configureFilters(filters);
        setFilters([]);
        setShowAdvancedFilter(false)
        message.success('Changes Applied.')
    }

    return (
        <>
        <Modal
                maskClosable={false}
                closeIcon={<CloseOutlined style={{ color: "white" }} />}
                bodyStyle={{
                    backgroundColor: 'black',
                    border: "1px solid grey",
                    marginTop: 60
                }}
                visible={showAddFilter} footer={null} onCancel={() => { setShowAddFilter(false); }}>
                
                <div style={{ fontWeight: "600", color: "white" }}>Select Field </div>

                <div style={{ color: "white", marginTop: 30, marginBottom: 40 }}>
                    <label>Field</label>
                    <Select
                        showSearch
                        style={{ width: "100%", marginTop: 10 }}
                        placeholder="Select field"
                        value={field}
                        onChange={(value) => {
                            setField(value);
                        }}
                    >
                        {fields.map(field => <Option value={field.value}>{field.label}</Option>)}
                    </Select>
                </div>


                <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                    <Button onClick={() => { setShowAddFilter(false); }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">BACK</Button>
                    <Button onClick={() => {
                        const found = filters.find(f => f.field == field);

                        if(found) {
                            message.error('Filter already exists');
                        }else {
                            setShowAddFilter(false);
                            const fieldValue = { field,  type: fieldKeyValue[field].type, label: fieldKeyValue[field].label, value: fieldKeyValue[field].value, options: fieldKeyValue[field]?.options };
                            setFilters(prevState => {
                                prevState.push(fieldValue);
                                return [...prevState];
                            })
                        }
                    }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">OK</Button>
                </div>
            </Modal >
            <Modal
                maskClosable={false}
                closeIcon={<CloseOutlined style={{ color: "white" }} />}
                bodyStyle={{
                    backgroundColor: 'black',
                    border: "1px solid grey"
                }}
                visible={showAdvancedFilter} footer={null} onCancel={() => { setShowAdvancedFilter(false); }}>
                <div style={{ fontWeight: "600", color: "white" }}>Configure Filters</div>

                {filters.map((filter, index) => {

                    return(
                        <div style={{ color: "white", margin: "30px 0" }}>
                            <label><DeleteOutlined onClick={() => {
                                let newFilters = [...filters];
                                newFilters = newFilters.filter((f, i) => i !== index);
                                setFilters(newFilters)
                            }} /> {filter.label}: </label>
                            {filter.type == 'string' && <Input value={filter.value} onChange={(e) => {
                                const newFilters = [...filters];
                                newFilters[index].value = e.target.value; 
                                setFilters(newFilters)
                            }} style={{ marginTop: 10 }} placeholder={filter.label} />}
                            {filter.type == 'range' && <div>
                            
                            <Slider range step={filter.step || 1} defaultValue={[1, 10]} value={filter.value} onChange={(e) => {
                               const newFilters = [...filters];
                               newFilters[index].value = e; 
                               setFilters(newFilters)
                            }}  />
                            <div style={{ marginTop: 15 }}>

                            <span>
                                    <span style={{ marginRight: 5 }}>1.</span>
                                    <InputNumber
                                        value={filter?.value?.[0]}
                                        onChange={(number) => {
                                            const newFilters = [...filters];
                                            if(!newFilters[index].value) [0, 1];
                                            newFilters[index].value[0] = number; 
                                            setFilters(newFilters)
                                        }}
                                    />
                                </span>

                                <span style={{ margin: '0 16px' }}>
                                    <span style={{ marginRight: 5 }}>2.</span>
                                    <InputNumber
                                        value={filter?.value?.[1]}
                                        onChange={(number) => {
                                            const newFilters = [...filters];
                                            if(!newFilters[index].value) [0, 1];
                                            newFilters[index].value[1] = number; 
                                            setFilters(newFilters)
                                        }}
                                    />
                                </span>
                               
                            </div>
                           
                             </div>}
                            {filter.type == 'boolean' &&  <Switch size="small" checked={filter.value} onChange={(e) => {
                                  const newFilters = [...filters];
                                  newFilters[index].value = e;
                                  setFilters(newFilters)
                            }} />}
                            {filter.type == 'dropdown' &&  <Select
                                showSearch
                                style={{ width: "100%", marginTop: 10 }}
                                placeholder="Select value"
                                value={filter.value}
                                onChange={(e) => {
                                    const newFilters = [...filters];
                                    newFilters[index].value = e;
                                    setFilters(newFilters)
                                }}
                            >
                            {filter?.options.map(f => <Option value={f}>{f}</Option>)}
                            </Select>}
                    </div>
                    )
                })}
               
                <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end", marginTop: 15, marginBottom: 25 }}>

                    <div style={{}}><Button onClick={() => {
                        setShowAddFilter(true);
                    }} style={{ backgroundColor: "#161616", color: "white", flex: 1,  }} >Add Filter</Button></div>
                </div>

                <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                    <Button onClick={() => { goBack() }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">BACK</Button>
                    <Button onClick={() => {
                        handleFilters();
                    }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">APPLY FILTERS</Button>
                </div>
            </Modal >
        </>
    );
};

export default AdvancedFilter;